import type { Product } from '@/types';

export const products: Product[] = [
  // Handheld Acoustic Imagers
{
    id: 'M72-M140',
    model: 'SoundPin M72/M140',
    name: 'Smart phone Acoustic Imager',
    category: 'Smartphone-Acoustic-Imager',
    description: 'The SoundPin M72/M140 Smart phone Acoustic Imager is a innovative Smart phone-based acoustic imaging solution that connects to your mobile device via Type-C. Available in two models: DES-M72LC (72 microphones) and DES-M140 (140 microphones), it provides visual leak detection, gas leak localization, and airtightness testing capabilities.',
    shortDescription: 'Smart phone-based acoustic imager with 72/140 microphones',
    image: '/Img/2026/04/soundpin-01.png',
    gallery: [
      '/Img/2026/04/soundpin-02.jpg',
      '/Img/2026/04/soundpin-03.jpg'
    ],
    features: [
      {
        icon: 'Smart phone',
        title: 'Type-C Phone Connection',
        description: 'Connects directly to your Smart phone via Type-C for instant acoustic imaging.'
      },
      {
        icon: 'AppWindow',
        title: 'SoundPin APP',
        description: 'Dedicated mobile application for real-time acoustic visualization and analysis.'
      },
      {
        icon: 'Mic',
        title: '72/140 Microphones',
        description: 'High-density microphone arrays for precise sound source localization.'
      },
      {
        icon: 'Camera',
        title: '5MP Visible Camera',
        description: 'Integrated camera for visual reference and documentation.'
      },
      {
        icon: 'Share2',
        title: 'Android / HarmonyOS Support',
        description: 'Works with both Android and HarmonyOS Smart phones.'
      },
      {
        icon: 'Feather',
        title: 'Ultra-Lightweight',
        description: 'Weighs less than 170g for comfortable handheld use.'
      }
    ],
    specifications: [
      {
        category: 'Model Comparison',
        items: [
          { label: 'Model', value: 'DES-M72LC | DES-M140', unit: '' },
          { label: 'Number of Microphones', value: '72 | 140', unit: '' },
          { label:"Imaging Frequency",value:"5 kHz ~ 50 kHz | 2 kHz ~ 100 kHz", unit: '' },
          { label: 'Testing Distance', value: '0.3~80m | 0.3~130m', unit: '' },
          { label: 'Microphone Sensitivity', value: '-26 dBFS | -26 dBFS', unit: '' },
          { label: 'Microphone SNR', value: '63 dB | 63 dB', unit: '' },
          { label: 'Visible Light Camera', value: '5MP | 5MP', unit: '' },
          { label: 'Sound Pressure Level', value: 'Supported | Supported', unit: '' },
          { label: 'Leakage Point Localization', value: 'Supported | Supported', unit: '' },
          { label: 'Partial Discharge Localization', value: 'Not Supported | Supported', unit: '' },
          { label: 'Abnormal Sound Localization', value: 'Supported | Supported', unit: '' },
          { label: 'Simultaneous Sound Sources', value: '2 | Multiple', unit: '' },
          { label: 'Minimum Detectable Leakage', value: '30ml/min, 150kPa, 2m | 30ml/min, 150kPa, 3m', unit: '' },
          { label: 'Localization Accuracy', value: '10mm (1m test distance) | 5mm (1m test distance)', unit: '' },
          { label: 'Image Format', value: 'JPG | JPG', unit: '' },
          { label: 'Video Format', value: 'Phone Screen Recording | Phone Screen Recording', unit: '' },
          { label: 'Interface', value: 'Type-C | Type-C', unit: '' },
          { label: 'Supported Systems', value: 'Android / HarmonyOS | Android / HarmonyOS', unit: '' },
          { label: 'Operating Temperature', value: '-20~50°C | -20~50°C', unit: '' },
          { label: 'Operating Humidity', value: '<95% (non-condensing) | <95% (non-condensing)', unit: '' },
          { label: 'Power Consumption', value: '3.3w | 3.9w', unit: '' },
          { label: 'Protection Rating', value: 'IP54 (optional) | IP54 (optional)', unit: '' },
          { label: 'Dimensions', value: 'φ86.6mm, 38.9mm thickness | φ86.6mm, 38.9mm thickness', unit: '' },
          { label: 'Weight', value: '<170g | <170g', unit: '' },
          { label: 'Warranty', value: '2 years | 2 years', unit: '' }
        ]
      },
      {
        category: 'Key Applications',
        items: [
          { label: 'Visual Vacuum Leak Detection', value: 'Supported', unit: '' },
          { label: 'High-pressure Gas Leak Localization', value: 'Supported', unit: '' },
          { label: 'Airtightness Testing', value: 'Supported', unit: '' },
          { label: 'Mechanical Fault Diagnosis', value: 'Supported', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'vacuum-leak',
        title: 'Visual Vacuum Leak Detection',
        description: 'Visualize and pinpoint vacuum leaks in HVAC systems, refrigeration equipment, and industrial machinery.',
        image: '/Img/2026/04/sound-point-vacuum-leak.jpg'
      },
      {
        id: 'gas-leak',
        title: 'High-pressure Gas Leak Localization',
        description: 'Quickly locate gas leaks in pipelines, valves, and connections for safety and energy savings.',
        image: '/Img/2026/04/sound-point-gas-leak.jpg'
      },
      {
        id: 'airtightness',
        title: 'Airtightness Testing',
        description: 'Test the airtightness of enclosures, windows, doors, and sealed systems.',
        image: '/Img/2026/04/sound-point-airtightness.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'SoundPin M72/M140 Datasheet',
        downloadUrl: '/downloads/Sound-Pin-Datasheet.pdf',
        size: '2.3 MB',
        language: 'English'
      },
      {
        type: 'manual',
        title: 'User Manual',
        downloadUrl: '/downloads/Sound-Pin-User-Manual.pdf',
        size: '4.5 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['des-c136', 'des-t163pad'],
    seo: {
      title: 'SoundPin M72/M140 Smart phone Acoustic Imager | KeyGoTech',
      description: 'Innovative Smart phone-based acoustic imager with 72/140 microphones for leak detection and sound localization.',
      keywords: ['mobile acoustic imager', 'sound point', 'phone acoustic camera', 'leak detection', 'Smart phone acoustic imaging']
    }
  },
  {
    id: 'des-c136',
    model: 'DES-C136',
    name: 'Handheld Acoustic Imager',
    category: 'handheld',
    description: 'The DES-C136 is a professional handheld acoustic imager designed for industrial maintenance and inspection. With 136 MEMS microphones and advanced beamforming technology, it enables precise localization of sound sources in noisy industrial environments.',
    shortDescription: '136-channel handheld acoustic imager for industrial inspection',
    image: '/Img/EN/136-小图.jpg',
    gallery: [
      '/Img/2026/02/136-1.jpg',
      '/Img/2026/02/136-2.jpg',
      '/Img/2026/02/136-3.jpg'
    ],
    features: [
      {
        icon: 'Mic',
        title: '136 MEMS Microphones',
        description: 'High-density microphone array for precise sound source localization with superior spatial resolution.'
      },
      {
        icon: 'Display',
        title: '5-inch Touchscreen',
        description: 'High-brightness LCD display visible even in direct sunlight for outdoor inspections.'
      },
      {
        icon: 'Battery',
        title: '5.5-hour Battery Life',
        description: 'Long-lasting rechargeable battery supports extended field operations.'
      },
      {
        icon: 'Design',
        title: 'Ultra-Compact Design',
        description: 'Industry-leading portability at only 150×110×80mm and <800g �?professional 136-channel performance in a pocket-sized design.'
      },
      {
        icon: 'Shield',
        title: 'IP54 Rated',
        description: 'Dust and water splash protection for harsh industrial environments.'
      },
      {
        icon: 'Zap',
        title: 'Real-time Analysis',
        description: 'Instant acoustic imaging with up to 100 FPS refresh rate.'
      }
    ],
    specifications: [
      {
        category: 'Acoustic Performance',
        items: [
          { label: 'Number of Microphones', value: '136', unit: 'channels' },
          { label: 'Frequency Range', value: '2-100', unit: 'kHz' },
          { label: 'Ultra-Compact Design', value: '150×110×80mm, <800g', unit: '' },
          { label: 'Detection Distance', value: '0.08-130', unit: 'm' },
          { label: 'Macro Acoustic Imaging', value: '<0.2m', unit: 'Supported' },
           { label: 'Minimum Detectable Leakage', value: '30ml/min, 150kPa, 3m', unit: '' },
             { label: 'Acoustic Imaging Bandwidth', value: '>90', unit: 'kHz' },
          { label: 'PRPD Pattern', value: '', unit: 'Supported' }
        ]
      },
      {
        category: 'Display & Interface',
        items: [
          { label: 'Screen Size', value: '5', unit: 'inch' },
          { label: 'Resolution', value: '1280×720', unit: 'pixels' }
        ]
      },
      {
        category: 'Physical',
        items: [
          { label: 'Dimensions', value: '150×110×80', unit: 'mm' },
          { label: 'Weight', value: '<800', unit: 'g' },
          { label: 'Protection Rating', value: 'IP54 (optional)', unit: '' },
          { label: 'Operating Temperature', value: '-20 to 50', unit: '°C' },
          { label: 'Operating Humidity', value: '<95%', unit: 'RH (non-condensing)' },
          { label: 'Explosion Protection', value: 'Ex ic IIC T6 Gc', unit: '(optional)' }
        ]
      },
      {
        category: 'Power & Storage',
        items: [
          { label: 'Battery Capacity', value: '3300', unit: 'mAh' },
          { label: 'Operating Time', value: '5.5', unit: 'hours' },
          { label: 'Storage Capacity', value: '128', unit: 'GB' }
        ]
      }
    ],
    applications: [
      {
        id: 'partial-discharge',
        title: 'Partial Discharge Detection',
        description: 'Detect and localize partial discharge in high-voltage equipment, transformers, and switchgear before failures occur.',
        image: '/Img/EN/应用案例英文_01.png'
      },
      {
        id: 'gas-leak',
        title: 'Gas Leak Detection',
        description: 'Visualize and pinpoint compressed air and gas leaks in pipelines, valves, and connections for energy savings.',
        image: 'solution-industrial.jpg'
      },
      {
        id: 'mechanical',
        title: 'Mechanical Fault Diagnosis',
        description: 'Identify bearing wear, gear defects, and other mechanical issues through acoustic signature analysis.',
        image: '/Img/EN/solution_img2.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'DES-C136 Datasheet',
        downloadUrl: '/downloads/DES-C136 Mini Acoustic Imager.pdf',
        size: '2.4 MB',
        language: 'English'
      },
      {
        type: 'manual',
        title: 'User Manual',
        downloadUrl: '/downloads/DES-C136-User-Manual.pdf',
        size: '5.8 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['des-t163pad', 'des-c200'],
    seo: {
      title: 'DES-C136 Handheld Acoustic Imager | KeyGoTech',
      description: 'Professional 136-channel handheld acoustic imager for partial discharge detection, gas leak detection, and mechanical fault diagnosis.',
      keywords: ['acoustic imager', 'DES-C136', 'partial discharge detection', 'gas leak detection', 'industrial inspection']
    }
  },
  {
    id: 'des-t163pad',
    model: 'DES-T163Pad',
    name: 'Tablet Acoustic Imager',
    category: 'handheld',
    description: 'The DES-T163Pad combines a powerful 163-channel microphone array with tablet convenience. Its large display and intuitive interface make it ideal for detailed acoustic analysis and documentation in the field.',
    shortDescription: '163-channel tablet acoustic imager with large display',
    image: '/Img/EN/163-小图.jpg',
    gallery: [
       '/Img/2026/02/163-1.jpg',
      '/Img/2026/02/163-2.jpg',
      '/Img/2026/02/163-3.jpg'
    ],
    features: [
      {
        icon: 'Mic',
        title: '163 MEMS Microphones',
        description: 'Ultra-high density array for exceptional acoustic imaging precision.'
      },
      {
        icon: 'Display',
        title: '7-inch HD Display',
        description: 'Large screen for detailed analysis and comfortable viewing during extended use.'
      },
      {
        icon: 'Cpu',
        title: 'Advanced Processing',
        description: 'High-performance processor for real-time beamforming and analysis.'
      },
      {
        icon: 'Camera',
        title: 'Dual Camera System',
        description: 'Visible and thermal imaging for comprehensive inspection documentation.'
      },
      {
        icon: 'HardDrive',
        title: 'Large Storage',
        description: '128GB internal storage for extensive data logging and reporting.'
      },
      {
        icon: 'Usb',
        title: 'Multiple Interfaces',
        description: 'USB-C, HDMI, and SD card slot for flexible data management.'
      }
    ],
    specifications: [
      {
        category: 'Acoustic Performance',
        items: [
          { label: 'Number of Microphones', value: '163', unit: 'channels' },
          { label: 'Frequency Range', value: '2-100', unit: 'kHz' },
          { label: 'Acoustic Imaging Bandwidth', value: '>90', unit: 'kHz' },
          { label: 'Detection Distance', value: '0.3-200', unit: 'm' },
          { label: 'Macro Acoustic Imaging', value: '<0.2m', unit: 'Not supported' },
          { label: 'Minimum Detectable Leakage', value: '30ml/min, 150kPa, 3m', unit: '' },
           { label: 'Acoustic Imaging Bandwidth', value: '>90', unit: 'kHz' },
          { label: 'PRPD Pattern', value: '', unit: 'Supported' }
        ]
      },
      {
        category: 'Display & Interface',
        items: [
          { label: 'Screen Size', value: '7', unit: 'inch' },
          { label: 'Resolution', value: '1920×1200', unit: 'pixels' }
        ]
      },
      {
        category: 'Physical',
        items: [
          { label: 'Dimensions', value: '232×165×86', unit: 'mm' },
          { label: 'Weight', value: '1.3', unit: 'kg' },
          { label: 'Protection Rating', value: 'IP54 (optional)', unit: '' },
          { label: 'Operating Temperature', value: '-20 to 50', unit: '°C' },
          { label: 'Operating Humidity', value: '<95%', unit: 'RH (non-condensing)' },
          { label: 'Explosion Protection', value: 'Ex ic IIC T6 Gc', unit: '(optional)' }
        ]
      },
      {
        category: 'Power & Storage',
        items: [
          { label: 'Battery Capacity', value: '3300', unit: 'mAh' },
          { label: 'Operating Time', value: '4', unit: 'hours' },
          { label: 'Storage Capacity', value: '128', unit: 'GB' }
        ]
      }
    ],
    applications: [
      {
        id: 'power-grid',
        title: 'Power Grid Inspection',
        description: 'Comprehensive inspection of substations, transmission lines, and distribution equipment.',
        image: '/Img/EN/应用案例英文_02.png'
      },
      {
        id: 'manufacturing',
        title: 'Manufacturing Quality Control',
        description: 'Acoustic quality inspection in production lines and assembly processes.',
        image: '/Img/EN/solution_img3.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'DES-T163Pad Datasheet',
        downloadUrl: '/downloads/DES-T163Pad Acoustic Imager.pdf',
        size: '2.8 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['des-c136', 'des-c200', 'des-t168tpt'],
    seo: {
      title: 'DES-T163Pad Tablet Acoustic Imager | KeyGoTech',
      description: '163-channel tablet acoustic imager with 10-inch display for professional industrial inspection and acoustic analysis.',
      keywords: ['acoustic imager', 'DES-T163Pad', 'tablet acoustic camera', 'industrial inspection']
    }
  },
  {
    id: 'des-c200',
    model: 'DES-C200',
    name: 'Advanced Handheld Acoustic Imager',
    category: 'handheld',
    description: 'The DES-C200 features our largest handheld microphone array with 212 channels, delivering professional-grade acoustic imaging performance for the most demanding inspection tasks.',
    shortDescription: '212-channel advanced handheld acoustic imager',
    image: '/Img/2025/04/des-c200-small.jpg',
    gallery: [
        '/Img/2026/02/212-1.jpg',
      '/Img/2026/02/212-2.jpg',
    ],
    features: [
      {
        icon: 'Mic',
        title: '212 MEMS Microphones',
        description: 'Industry-leading microphone count for maximum imaging precision.'
      },
      {
        icon: 'Zap',
        title: ' Ultra-wide Frequency',
        description: 'Extended frequency range from 2 kHz to 100 kHz for comprehensive analysis.'
      },
      {
        icon: 'Target',
        title: 'Ultra-Compact & Lightweight',
        description: '212-channel performance in a 750g, pocket-sized design (158×112×84mm)'
      },
      {
        icon: 'Settings',
        title: 'Replaceable Battery',
        description: 'Design Enable all-day field operations with quick battery swap.'
      }
    ],
    specifications: [
      {
        category: 'Acoustic Performance',
        items: [
          { label: 'Number of Microphones', value: '212', unit: 'channels' },
          { label: 'Frequency Range', value: '2-100', unit: 'kHz' },
          { label: 'Ultra-Compact Design', value: '750g, 158×112×84mm', unit: 'kHz' },
          { label: 'Detection Distance', value: '0.3-200', unit: 'm' },
          { label: 'Macro Acoustic Imaging', value: '<0.2m', unit: 'Not supported' },
          { label: 'Minimum Detectable Leakage', value: '30ml/min, 150kPa, 4m', unit: '' },
          { label: 'PRPD Pattern', value: '', unit: 'Supported' }
        ]
      },
      {
        category: 'Display & Interface',
        items: [
          { label: 'Screen Size', value: '5', unit: 'inch' },
          { label: 'Resolution', value: '1280×720', unit: 'pixels' }
        ]
      },
      {
        category: 'Physical',
        items: [
          { label: 'Dimensions', value: '158×112×84', unit: 'mm' },
          { label: 'Weight', value: '750', unit: 'g' },
          { label: 'Protection Rating', value: 'IP54 (optional)', unit: '' },
          { label: 'Operating Temperature', value: '-20 to 50', unit: '°C' },
          { label: 'Operating Humidity', value: '<95%', unit: 'RH (non-condensing)' },
          { label: 'Explosion Protection', value: 'Ex ib IIC T4 Gb', unit: '(optional)' }
        ]
      },
      {
        category: 'Power & Storage',
        items: [
          { label: 'Battery Capacity', value: '3300', unit: 'mAh' },
           { label:'Battery Type', value:'Replaceable / Field-swappable'},
          { label: 'Operating Time', value: '2.75', unit: 'hours' },
          { label: 'Storage Capacity', value: '128', unit: 'GB' }
        ]
      }
    ],
    applications: [
      {
        id: 'aerospace',
        title: 'Aerospace Testing',
        description: 'High-precision acoustic analysis for aerospace component testing and validation.',
        image: '/Img/EN/solution_img4.jpg'
      },
      {
        id: 'research',
        title: 'R&D Applications',
        description: 'Research and development acoustic testing with advanced analysis capabilities.',
        image: '/Img/EN/solution_img5.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'DES-C200 Datasheet',
        downloadUrl: '/downloads/des-c200 Acoustic Imager.pdf',
        size: '3.1 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['des-c136', 'des-t163pad'],
    seo: {
      title: 'DES-C200 Advanced Handheld Acoustic Imager | KeyGoTech',
      description: '212-channel professional acoustic imager with  Swappable Battery range for demanding industrial and research applications.',
      keywords: ['acoustic imager', 'DES-C200', 'advanced acoustic camera', 'industrial testing']
    }
  },
  // Fixed Acoustic Imager
  {
    id: 'des-t168tpt',
    model: 'DES-T168TPT',
    name: 'Fixed-mount Acoustic Imager',
    category: 'fixed',
    description: 'The DES-T168TPT is a rugged fixed-mount acoustic imager designed for continuous monitoring applications. With 168 microphones and industrial-grade construction, it provides 24/7 acoustic surveillance for critical equipment.',
    shortDescription: '168-channel fixed-mount acoustic imager for continuous monitoring',
    image: '/Img/2026/03/Fixed-mount-Systems.jpg',
    gallery: [
      '/Img/2026/03/Fixed-mount-Systems.jpg',
      '/Img/2026/03/Fixed-mount-Systems-1.jpg',
    ],
    features: [
      {
        icon: 'Mic',
        title: '168 MEMS Microphones',
        description: 'High-density array with -26 dBFS sensitivity for precise acoustic detection.'
      },
      {
        icon: 'Camera',
        title: '8MP Visual Camera',
        description: 'Integrated 8-megapixel camera for clear visual reference and documentation.'
      },
      {
        icon: 'Wifi',
        title: 'Multi-Protocol Support',
        description: 'HTTP / TCP / RTSP / RTMP protocols for flexible system integration.'
      },
      {
        icon: 'Shield',
        title: 'IP65 Rated',
        description: 'Dust-tight and protected against water jets for harsh industrial environments.'
      },
      {
        icon: 'Thermometer',
        title: 'Wide Temperature',
        description: 'Operates from -40°C to +70°C for extreme environments.'
      },
      {
        icon: 'Power',
        title: 'Dual Power Options',
        description: 'Supports 12-26V DC or 48V PoE for flexible installation.'
      }
    ],
    specifications: [
      {
        category: 'Acoustic Performance',
        items: [
          { label: 'Microphone Count', value: '168', unit: 'channels' },
          { label: 'Microphone Sensitivity', value: '-26', unit: 'dBFS (1 kHz, 94 dB SPL)' },
          { label: 'Microphone SNR', value: '64.3', unit: 'dB(A)' },
          { label: 'Sampling Rate', value: '200', unit: 'kS/s' },
          { label: 'Frequency Range', value: '2 - 100', unit: 'kHz' },
          { label: 'Min Detectable Leak', value: '2.5m, 1.72bar, 0.25ml/s', unit: '' },
          { label: 'Test Distance', value: '0.5 - 150', unit: 'm' }
        ]
      },
      {
        category: 'Imaging & Communication',
        items: [
          { label: 'Camera Resolution', value: '8', unit: 'MP' },
          { label: 'Communication', value: 'HTTP / TCP / RTSP / RTMP', unit: '' }
        ]
      },
      {
        category: 'Power & Physical',
        items: [
          { label: 'Power Supply', value: '12 - 26 V DC / 48 V PoE', unit: '' },
          { label: 'Weight', value: '1.3', unit: 'kg' },
          { label: 'Dimensions', value: '230 × 230 × 80', unit: 'mm' }
        ]
      },
      {
        category: 'Environmental',
        items: [
          { label: 'Operating Temperature', value: '-40 ~ 70', unit: '°C' },
          { label: 'Operating Humidity', value: '5% - 95%, non-condensing', unit: '' },
          { label: 'Protection Rating', value: 'IP65', unit: '' },
          { label: 'Explosion Protection', value: 'Optional', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'continuous-monitoring',
        title: 'Continuous Equipment Monitoring',
        description: '24/7 acoustic monitoring of critical machinery and electrical equipment.',
        image: '/Img/EN/固定式设备英文_2.png'
      },
      {
        id: 'predictive-maintenance',
        title: 'Predictive Maintenance',
        description: 'Early detection of equipment degradation for proactive maintenance scheduling.',
        image: '/Img/EN/固定式设备英文_3.png'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'DES-T168TPT Datasheet',
        downloadUrl: '/downloads/DES-T168TPT Fixed Acoustic lmager.pdf',
        size: '2.2 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['f-series-f72-f140', 't144'],
    seo: {
      title: 'DES-T168TPT Fixed-mount Acoustic Imager | KeyGoTech',
      description: '168-channel fixed-mount acoustic imager for continuous 24/7 industrial monitoring and predictive maintenance.',
      keywords: ['fixed acoustic imager', 'DES-T168TPT', 'continuous monitoring', 'predictive maintenance', 'industrial acoustic camera']
    }
  },
  // Acoustic Camera Modules
  {
    id: 'pcb-modules',
    model: 'ODES Series',
    name: 'PCB Acoustic Imaging Modules',
    category: 'modules',
    subcategory: 'pcb',
    description: 'High-performance PCB acoustic imaging modules for OEM integration. Available in multiple configurations from 136 to 345 channels, supporting various applications from compact all-in-one devices to high-performance acoustic imaging systems.',
    shortDescription: 'PCB acoustic imaging modules - 136 to 345 channels for OEM integration',
    image: '/Img/2025/06/pcb02.jpg',
    gallery: [
      '/Img/2025/06/pcb02.jpg'
    ],
    features: [
      {
        icon: 'CircuitBoard',
        title: 'Compact PCB Design',
        description: 'Space-optimized PCB layout for easy integration into your products.'
      },
      {
        icon: 'Settings',
        title: 'Multiple Configurations',
        description: '5 models available with 136 to 345 microphone channels.'
      },
      {
        icon: 'Code',
        title: 'Cross-Platform SDK',
        description: 'SDK supports Android, Linux, iOS, and Windows platforms.'
      },
      {
        icon: 'Headphones',
        title: 'Technical Support',
        description: 'Dedicated engineering support and 3D PCB files provided.'
      }
    ],
    specifications: [
      {
        category: 'Model Comparison',
        items: [
          { label: 'Model', value: 'ODES-136G1 | ODES-210G4 | ODES-230G5 | ODES-234G2 | ODES-345G3', unit: '' },
          { label: 'Application', value: 'Compact/Mobile | High-performance | High-performance | High-performance | High-performance', unit: '' },
          { label: 'Microphones', value: '136 | 210 | 230 | 234 | 345', unit: 'channels' },
          { label: 'Array Pattern', value: 'Random | Circular | Circular | Hybrid | Hybrid', unit: '' },
          { label: 'Array Size', value: '52 | 56 | 64 | 112 | 112', unit: 'mm' },
          { label: 'Weight', value: '35 | 65 | 65 | 95 | 95', unit: 'g' },
          { label: 'Dimensions', value: '71×63×12 | 81.5×71.5×12 | 81.5×71.5×12 | 119×119×12 | 119×119×12', unit: 'mm' },
          { label: 'Power', value: '2.5 | 3.5 | 3.5 | 3.5 | 4.6', unit: 'W' },
          { label: 'Detection Range', value: '0.3-130 | 0.3-200 | 0.3-200 | 0.3-200 | 0.3-200', unit: 'm' },
          { label: 'Lateral Resolution', value: '<0.35m | <0.20m | <0.20m | <0.20m | <0.20m', unit: '@1m,40kHz' }
        ]
      },
      {
        category: 'Acoustic Performance (All Models)',
        items: [
          { label: 'Microphone Type', value: 'High-sensitivity digital MEMS', unit: '' },
          { label: 'Sensitivity', value: '-26', unit: 'dBFS@1kHz' },
          { label: 'Max SPL', value: '120', unit: 'dB' },
          { label: 'SNR', value: '64', unit: 'dB@1kHz' },
          { label: 'Sampling Rate', value: '200', unit: 'kHz' },
          { label: 'Imaging Frequency', value: '2-100', unit: 'kHz' },
          { label: 'Positioning Error', value: '<0.05', unit: 'm @1m,40kHz' },
          { label: 'Dynamic Range', value: '>10 to >12', unit: 'dB@40kHz' },
          { label: 'Min Imaging SPL', value: '<20', unit: 'dB SPL' },
          { label: 'Frame Rate', value: '25', unit: 'FPS' }
        ]
      },
      {
        category: 'Interface & Environment (All Models)',
        items: [
          { label: 'Interface', value: 'USB 2.0', unit: '' },
          { label: 'Power Supply', value: '5V DC (max 17V)', unit: '' },
          { label: 'Temperature', value: '-20 to 50', unit: '°C' },
          { label: 'Protection', value: 'IP54 (with enclosure)', unit: '' }
        ]
      },
      {
        category: 'Software Features (All Models)',
        items: [
          { label: 'PRPD Pattern', value: 'Supported', unit: '' },
          { label: 'Leak Estimation', value: 'Supported', unit: '' },
          { label: 'Energy Loss Calculation', value: 'Supported', unit: '' },
          { label: 'Visible Light Camera', value: 'User-selectable, not included', unit: '' },
          { label: 'Design Files', value: '3D PCB files provided', unit: '' }
        ]
      }
    ],
    sdkFunctions: [
      {
        api: 'Start Imaging',
        function: 'Start real-time acoustic imaging calculation',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Stop Imaging',
        function: 'Stop imaging calculation, enter standby mode',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Get Audio Signal',
        function: 'Read continuous real-time audio signal from specified microphone',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Get Source Audio',
        function: 'Read continuous real-time audio signal at maximum sound source point',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Get Mic SPL',
        function: 'Read SPL of all microphones in real-time, including raw and filtered signals',
        type: 'Real-time',
        note: 'Linear SPL'
      },
      {
        api: 'Get PRPD',
        function: 'Calculate PRPD pattern from audio signal',
        type: 'Real-time/Post-processing',
        note: ''
      },
      {
        api: 'Get Leak Estimate',
        function: 'Read leak volume and energy loss estimates. Configurable parameters: distance, gas pressure, gas temperature, gas type, energy price, compressor efficiency',
        type: 'Real-time/Post-processing',
        note: ''
      },
      {
        api: 'Get Spectrum',
        function: 'Calculate power spectrum from audio signal',
        type: 'Real-time/Post-processing',
        note: ''
      },
      {
        api: 'Get Time-Frequency',
        function: 'Calculate joint time-frequency spectrum from audio signal',
        type: 'Real-time/Post-processing',
        note: ''
      },
      {
        api: 'Get Mic Status',
        function: 'Return fault code when failed microphones exceed minimum allowed ratio',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Set Frequency Range',
        function: 'Set upper and lower limits for acoustic imaging frequency',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Set Imaging Mode',
        function: 'Selectable: Single source, Multiple sources, Sound field distribution',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Set Detection Mode',
        function: 'Selectable: Partial discharge, Leak, Abnormal noise',
        type: 'Real-time',
        note: 'PD: Returns PRPD; Leak: Returns leak estimate; Noise: Imaging only'
      },
      {
        api: 'Firmware Update',
        function: 'Send upgrade package to module for online firmware upgrade',
        type: 'Real-time',
        note: ''
      },
      {
        api: 'Read Firmware Version',
        function: 'Return firmware version number',
        type: 'Real-time',
        note: ''
      }
    ],
    applications: [
      {
        id: 'oem-integration',
        title: 'OEM Integration',
        description: 'Integrate acoustic imaging capabilities into your own products and systems.',
        image: '/Img/2025/12/声学成像机芯与模块_01.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'ODES Series PCB Modules Datasheet',
        downloadUrl: '/downloads/ODES-Series-PCB-Modules.pdf',
        size: '2.5 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['core-o72-o140', 'f-series-f72-f140'],
    seo: {
      title: 'ODES Series PCB Acoustic Imaging Modules | KeyGoTech',
      description: 'High-performance PCB acoustic imaging modules with 136-345 channels. SDK supports Android, Linux, iOS, and Windows for OEM integration.',
      keywords: ['PCB acoustic module', 'ODES series', 'OEM acoustic imaging', 'acoustic imaging SDK', 'MEMS microphone array']
    }
  },
  // Core Modules O72/O140
  {
    id: 'core-o72-o140',
    model: 'O72 / O140',
    name: 'Acoustic Imager Core Modules',
    category: 'modules',
    subcategory: 'core',
    description: 'High-performance acoustic imager core modules for system integration. Available in 72-channel (O72) and 140-channel (O140) configurations with complete processing electronics.',
    shortDescription: 'Acoustic imager core modules - 72/140 channels',
    image: '/Img/2026/03/O72-O140.jpg',
    gallery: [
      '/Img/2026/03/O72-O140.jpg',
      '/Img/2025/12/声学成像机芯与模块_03.jpg',
    ],
    features: [
      {
        icon: 'Cpu',
        title: 'Integrated Processing',
        description: 'Built-in beamforming processor for real-time acoustic imaging.'
      },
      {
        icon: 'Usb',
        title: 'Multiple Interfaces',
        description: 'USB 3.0 and Ethernet connectivity options.'
      },
      {
        icon: 'Video',
        title: 'Video Output',
        description: 'HDMI output for direct display connection.'
      },
      {
        icon: 'Save',
        title: 'Onboard Storage',
        description: 'MicroSD slot for local data logging.'
      }
    ],
    specifications: [
      {
        category: 'O72 Specifications',
        items: [
          { label: 'Microphones', value: '72', unit: 'channels' },
          { label: 'Frequency Range', value: '3-35', unit: 'kHz' },
          { label: 'Processor', value: 'ARM Cortex-A72', unit: '' },
          { label: 'RAM', value: '2', unit: 'GB' },
          { label: 'Storage', value: '16', unit: 'GB' }
        ]
      },
      {
        category: 'O140 Specifications',
        items: [
          { label: 'Microphones', value: '140', unit: 'channels' },
          { label: 'Frequency Range', value: '2-48', unit: 'kHz' },
          { label: 'Processor', value: 'ARM Cortex-A72 dual', unit: '' },
          { label: 'RAM', value: '4', unit: 'GB' },
          { label: 'Storage', value: '32', unit: 'GB' }
        ]
      },
      {
        category: 'Common Features',
        items: [
          { label: 'Video Output', value: 'HDMI 1.4', unit: '' },
          { label: 'USB', value: 'USB 3.0 OTG', unit: '' },
          { label: 'Ethernet', value: '10/100 Mbps', unit: '' },
          { label: 'Power', value: '5V/3A', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'system-integration',
        title: 'System Integration',
        description: 'Build custom acoustic imaging systems with our core modules.',
        image: '/Img/2025/12/声学成像机芯与模块_03.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'O-Series Core Modules Datasheet',
        downloadUrl: '/downloads/O-Series-Core-Modules.pdf',
        size: '2.0 MB',
        language: 'English'
      },
     /*{
        type: 'sdk',
        title: 'O-Series SDK',
        downloadUrl: '/downloads/O-Series-SDK.zip',
        size: '15.0 MB',
        language: 'English'
      }*/
    ],
    relatedProducts: ['pcb-modules', 'f-series-f72-f140'],
    isCompareProduct: true,
    compareWith: ['O72', 'O140'],
    seo: {
      title: 'O72 / O140 Acoustic Imager Core Modules | KeyGoTech',
      description: 'High-performance acoustic imager core modules with integrated processing. 72-channel and 140-channel options for system integration.',
      keywords: ['acoustic imager core', 'O72', 'O140', 'acoustic camera module', 'system integration']
    }
  },
  // F-Series Modules F72/F140
  {
    id: 'f-series-f72-f140',
    model: 'F72 / F140',
    name: 'F-Series Acoustic Camera Modules',
    category: 'modules',
    subcategory: 'f-series',
    description: 'Compact F-Series acoustic camera modules designed for flexible mounting and integration. Available in 72-channel (F72) and 140-channel (F140) configurations.',
    shortDescription: 'F-Series compact acoustic camera modules - 72/140 channels',
    image: '/Img/2026/03/F72-F140.jpg',
    gallery: [
      '/Img/2026/03/F72-F140.jpg',
      '/Img/2025/06/pcb04.png',
    ],
    features: [
      {
        icon: 'Minimize2',
        title: 'Compact Form Factor',
        description: 'Optimized size for space-constrained applications.'
      },
      {
        icon: 'Mount',
        title: 'Flexible Mounting',
        description: 'Multiple mounting options for various installation scenarios.'
      },
      {
        icon: 'Cable',
        title: 'Cable Management',
        description: 'Integrated cable routing for clean installation.'
      },
      {
        icon: 'Wrench',
        title: 'Easy Installation',
        description: 'Tool-free mounting and adjustment features.'
      }
    ],
    specifications: [
      {
        category: 'F72 Specifications',
        items: [
          { label: 'Microphones', value: '72', unit: 'channels' },
          { label: 'Array Diameter', value: '120', unit: 'mm' },
          { label: 'Weight', value: '350', unit: 'g' },
          { label: 'Mounting', value: 'M4 threaded holes', unit: '' }
        ]
      },
      {
        category: 'F140 Specifications',
        items: [
          { label: 'Microphones', value: '140', unit: 'channels' },
          { label: 'Array Diameter', value: '180', unit: 'mm' },
          { label: 'Weight', value: '520', unit: 'g' },
          { label: 'Mounting', value: 'M4/M6 threaded holes', unit: '' }
        ]
      },
      {
        category: 'Interface',
        items: [
          { label: 'Connection', value: 'High-density connector', unit: '' },
          { label: 'Cable Length', value: '2/5/10', unit: 'm options' },
          { label: 'Interface Board', value: 'Sold separately', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'robotics',
        title: 'Robotics Integration',
        description: 'Mount on robotic arms for automated acoustic inspection.',
        image: '/Img/2025/06/pcb03.jpg'
      },
      {
        id: 'production-line',
        title: 'Production Line Monitoring',
        description: 'Inline acoustic quality control in manufacturing processes.',
        image: '/Img/2025/06/pcb04.png'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'F-Series Modules Datasheet',
        downloadUrl: '/downloads/F-Series-Modules.pdf',
        size: '1.8 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['core-o72-o140', 'pcb-modules'],
    isCompareProduct: true,
    compareWith: ['F72', 'F140'],
    seo: {
      title: 'F72 / F140 F-Series Acoustic Camera Modules | KeyGoTech',
      description: 'Compact F-Series acoustic camera modules with flexible mounting options. 72-channel and 140-channel configurations available.',
      keywords: ['F-Series acoustic module', 'F72', 'F140', 'compact acoustic camera', 'robotics integration']
    }
  },
  // Acoustic Cameras
  {
    id: 't144',
    model: 'T144',
    name: 'T144 Acoustic Camera',
    category: 'cameras',
    description: 'The T144 is a high-performance acoustic camera featuring 144 microphones in a compact array design. Ideal for research, product development, and advanced industrial applications.',
    shortDescription: '144-channel high-performance acoustic camera',
    image: '/Img/2026/03/T144.jpg',
    gallery: [
      '/Img/2026/03/T144.jpg',
      '/Img/EN/通用声学-高性能英文_02.jpg',
    ],
    features: [
      {
        icon: 'Mic',
        title: '144 Microphones',
        description: 'High-density microphone array with optimized geometry for precise acoustic imaging.'
      },
      {
        icon: 'Zap',
        title: 'Wide Frequency Range',
        description: '25 Hz - 96 kHz analysis range covers audible to ultrasonic applications.'
      },
      {
        icon: 'Wifi',
        title: 'Wireless & Wired',
        description: 'Ethernet and WiFi connectivity for flexible deployment options.'
      },
      {
        icon: 'Scan',
        title: 'Real-time Imaging',
        description: '25 FPS real-time acoustic imaging with 0.2-130m detection range.'
      }
    ],
    specifications: [
      {
        category: 'Performance Parameters',
        items: [
          { label: 'Microphone Count', value: '144', unit: 'channels' },
          { label: 'Analysis Frequency Range', value: '25 Hz - 96', unit: 'kHz' },
          { label: 'Microphone Sensitivity', value: '-26', unit: 'dBFS (1 kHz, 94 dB SPL)' },
          { label: 'Microphone SNR', value: '64.3', unit: 'dB(A)' },
          { label: 'SPL Measurement Range', value: '30 ~ 124', unit: 'dB(A)' },
          {label:'Recommended Imaging Frequency Range', value: '  1kHz - 96kHz', unit: '' },
          { label: 'Audio Sampling Rate', value: '25.6 - 192', unit: 'kS/s/ch' },
          { label: 'Acoustic Refresh Rate', value: '25', unit: 'FPS real-time' },
          { label: 'Test Distance', value: '0.2 - 130', unit: 'm*' }
        ]
      },
      {
        category: 'Physical & Environmental',
        items: [
          { label: 'Communication', value: 'Ethernet / WiFi', unit: '' },
          { label: 'Dimensions', value: '300 × 300 × 80', unit: 'mm' },
          { label: 'Weight', value: '1.8', unit: 'kg' },
          { label: 'Operating Temperature', value: '0 ~ 50', unit: '°C' },
          { label: 'Operating Humidity', value: '10% ~ 85%, non-condensing', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'research',
        title: 'Acoustic Research',
        description: 'Advanced acoustic research and analysis applications.',
        image: '/Img/EN/通用声学-高性能英文_07.jpg'
      },
      {
        id: 'product-development',
        title: 'Product Development',
        description: 'Acoustic testing during product design and validation.',
        image: '/Img/EN/通用声学-高性能英文_08.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'T144 Datasheet',
        downloadUrl: '/downloads/T144-Datasheet.pdf',
        size: '2.5 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['high-performance-array', 'des-t163pad'],
    seo: {
      title: 'T144 Acoustic Camera | KeyGoTech',
      description: '144-channel high-performance acoustic camera for research and advanced industrial applications.',
      keywords: ['acoustic camera', 'T144', 'acoustic research', 'beamforming camera', 'ultrasonic imaging']
    }
  },
  {
    id: 'high-performance-array',
    model: 'KeyVES Series',
    name: 'High Performance Acoustic Array',
    category: 'cameras',
    description: 'Professional high-performance acoustic array series with 32 to 176 microphones. Available in multiple configurations: foldable U32, integrated T64 spiral array, large R128 for superior low-frequency performance, and modular R176 with detachable extension arms.',
    shortDescription: 'High-performance acoustic array series - 32 to 176 channels',
    image: '/Img/2026/03/High-Performance-Array.jpg',
    gallery: [
      '/Img/2026/03/High-Performance-Array.jpg',
      '/Img/2026/03/High-Performance-Array-1.jpg',
        '/Img/2026/03/High-Performance-Array-2.jpg',
    ],
    features: [
      {
        icon: 'Grid3x3',
        title: 'Multiple Configurations',
        description: 'U32 (foldable), T64 (spiral), R128 (large diameter), R176 (modular with extension arms).'
      },
      {
        icon: 'Maximize',
        title: 'Large Aperture',
        description: 'Up to 3.0m diameter for superior low-frequency performance and precision localization.'
      },
      {
        icon: 'Sliders',
        title: 'Flexible Sampling Rate',
        description: '16k - 256kHz adjustable sampling rate to suit various applications.'
      },
      {
        icon: 'Award',
        title: 'High Phase Consistency',
        description: '±3° phase consistency @1kHz ensures accurate beamforming results.'
      },
      {
        icon: 'Waves',
        title: 'Ultra-Low Frequency Localization',
        description: 'Down to 500 Hz for superior low-frequency acoustic source detection.'
      }
    ],
    specifications: [
      {
        category: 'Model Comparison',
        items: [
          { label: 'Model', value: 'KeyVES-U32 | KeyVES-T64 | KeyVES-R128 | KeyVES-R176', unit: '' },
          { label: 'Microphone Count', value: '32 | 64 | 128 | 176', unit: 'channels' },
          { label: 'Diameter', value: '1.4 m | 1.0 m | 3.0 m | 2.0 m', unit: '' },
           { label: 'Ultra-Low Frequency Localization', value: 'Down to 500 Hz', unit: '' },
          { label: 'Key Features', value: 'Foldable, compact storage | Integrated spiral array | Large size, better low-freq | Detachable arms, aluminum body', unit: '' },
          { label: 'Frequency Range*', value: '800 Hz ~ 12 kHz | 800 Hz ~ 12 kHz | 500 Hz ~ 12 kHz | 500 Hz ~ 20 kHz', unit: '' }
        ]
      },
      {
        category: 'Acoustic Performance (All Models)',
        items: [
          { label: 'Sampling Rate', value: '16k - 256k', unit: 'adjustable' },
          { label: 'Analysis Frequency Range', value: '20 Hz ~ 20', unit: 'kHz' },
          { label: 'Refresh Rate', value: '25', unit: 'FPS real-time (slow playback supported)' },
          { label: 'Microphone Sensitivity', value: '50', unit: 'mV/Pa' },
          { label: 'Phase Consistency', value: '±3', unit: '° @1kHz' },
          { label: 'Note', value: 'Lower frequencies achievable with advanced algorithms and reduced dynamic range', unit: '' }
        ]
      },
      {
        category: 'Physical & Environmental (All Models)',
        items: [
          { label: 'Weight (without tripod/case)', value: '3.5', unit: 'kg' },
          { label: 'Operating Temperature', value: '0 ~ 50', unit: '°C' },
          { label: 'Operating Humidity', value: '10% ~ 85%, non-condensing', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'wind-tunnel',
        title: 'Wind Tunnel Testing',
        description: 'Acoustic measurement in aerodynamic testing facilities.',
        image: '/Img/EN/通用声学-高性能英文_05.jpg'
      },
      {
        id: 'nvh-lab',
        title: 'NVH Laboratory',
        description: 'Noise, vibration, and harshness testing in controlled environments.',
        image: '/Img/EN/通用声学-高性能英文_06.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'High Performance Array Datasheet',
        downloadUrl: '/downloads/High-Performance-Array.pdf',
        size: '3.2 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['t144', 'signalpad'],
    seo: {
      title: 'KeyVES Series High Performance Acoustic Array | KeyGoTech',
      description: 'KeyVES series high-performance acoustic arrays with 32-176 channels. Foldable, spiral, and modular configurations for professional acoustic measurements.',
      keywords: ['KeyVES acoustic array', 'high performance acoustic array', 'foldable microphone array', 'acoustic camera', 'laboratory acoustic measurement']
    }
  },
  // Data Acquisition
  {
    id: 'usb-4228',
    model: 'USB-4228',
    name: 'USB Dynamic Signal Acquisition System',
    category: 'daq',
    description: 'The USB-4228 is a high-performance USB 3.0 dynamic signal acquisition card designed for sound and vibration signal testing and measurement. It features 4 synchronous acquisition channels with 24-bit resolution and up to 192 kS/s sampling rate. Additionally, it includes 2 analog output channels (24-bit, 192 kS/s), 4 digital inputs, and 4 digital outputs. The built-in USB hub supports multi-card cascading.',
    shortDescription: '4-channel USB 3.0 dynamic signal acquisition system',
    image: '/Img/2025/07/4228.jpg',
    gallery: [
      '/Img/2025/07/4228.jpg',
    ],
    features: [
      {
        icon: 'Usb',
        title: 'USB 3.0 Interface',
        description: '5 Gbps data transfer rate with built-in USB hub for multi-card cascading.'
      },
      {
        icon: 'Gauge',
        title: '4-Channel Input',
        description: '4 synchronous analog input channels, 24-bit resolution, up to 192 kS/s sampling rate.'
      },
      {
        icon: 'Zap',
        title: '2-Channel Output',
        description: '2 analog output channels, 24-bit resolution, 192 kS/s update rate.'
      },
      {
        icon: 'LayoutGrid',
        title: 'Digital I/O',
        description: '4 digital inputs and 4 digital outputs for flexible trigger and control.'
      }
    ],
    specifications: [
      {
        category: 'Analog Input',
        items: [
          { label: 'Channels', value: '4', unit: 'synchronous' },
          { label: 'Resolution', value: '24', unit: 'bit' },
          { label: 'Max Sampling Rate', value: '192', unit: 'kS/s' }
        ]
      },
      {
        category: 'Analog Output',
        items: [
          { label: 'Channels', value: '2', unit: '' },
          { label: 'Resolution', value: '24', unit: 'bit' },
          { label: 'Max Update Rate', value: '192', unit: 'kS/s' }
        ]
      },
      {
        category: 'Digital I/O',
        items: [
          { label: 'Digital Input', value: '4', unit: 'channels' },
          { label: 'Digital Output', value: '4', unit: 'channels' }
        ]
      },
      {
        category: 'Analysis Capabilities',
        items: [
          { label: 'Spectrum Analysis', value: 'Power Spectrum, Octave', unit: '' },
          { label: 'Level Measurement', value: 'Sound Pressure Level, Vibration Level', unit: '' },
          { label: 'Advanced Analysis', value: 'Sound Intensity, Acoustic Impedance', unit: '' },
          { label: 'Transfer Function', value: 'Frequency Response Function (FRF)', unit: '' },
          { label: 'Time-Frequency', value: 'Joint Time-Frequency Analysis', unit: '' },
          { label: 'Rotational', value: 'Order Tracking Analysis', unit: '' },
          { label: 'Structural', value: 'Modal Analysis', unit: '' },
          { label: 'Quality', value: 'Sound Quality Analysis', unit: '' }
        ]
      },
      {
        category: 'Interface & Connectors',
        items: [
          { label: 'Interface', value: 'USB 3.0', unit: '' },
          { label: 'Data Rate', value: '5', unit: 'Gbps' },
          { label: 'Analog I/O', value: '6 x BNC', unit: '(4 in, 2 out)' },
          { label: 'Tacho/Trigger/DIO', value: '2 x 10-pin, 3.81mm', unit: 'terminal blocks' },
          { label: 'Power', value: '2 x 3-pin, 3.81mm', unit: 'terminal blocks' },
          { label: 'Downstream USB', value: '1 x USB 3.0 Type-A', unit: '(hub)' },
          { label: 'Upstream USB', value: '1 x USB 3.0 Type-B', unit: '' }
        ]
      },
      {
        category: 'Physical & Environmental',
        items: [
          { label: 'Dimensions', value: '198 × 129 × 33', unit: 'mm' },
          { label: 'Weight', value: '422', unit: 'g' },
          { label: 'Operating Temperature', value: '0 ~ 60', unit: '°C' },
          { label: 'Storage Temperature', value: '-40 ~ 70', unit: '°C' },
          { label: 'Storage Humidity', value: '5% ~ 95% RH', unit: 'non-condensing' }
        ]
      },
      {
        category: 'Power',
        items: [
          { label: 'Power Options', value: 'External 10-30 VDC or USB Bus', unit: '' },
          { label: 'External Power', value: 'Typ. 150mA, Max 200mA', unit: '@24V' },
          { label: 'Bus Power', value: 'Typ. 700mA, Max 60mA', unit: '@5V' }
        ]
      }
    ],
    applications: [
      {
        id: 'field-testing',
        title: 'Field Testing',
        description: 'Portable data acquisition for on-site measurements.',
        image: '/Img/2025/07/4228.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'USB-4228 Datasheet',
        downloadUrl: '/downloads/USB-4228-Datasheet.pdf',
        size: '1.2 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['keydaq-8116', 'signalpad'],
    seo: {
      title: 'USB-4228 USB 3.0 Dynamic Signal Acquisition System | KeyGoTech',
      description: 'USB-4228 high-performance USB 3.0 dynamic signal acquisition card with 4-channel input, 2-channel output, and comprehensive analysis capabilities.',
      keywords: ['USB-4228', 'USB 3.0 DAQ', 'dynamic signal acquisition', 'sound and vibration testing', 'data acquisition system']
    }
  },
  {
    id: 'keydaq-8116',
    model: 'KeyDAQ-8116',
    name: 'KeyDAQ-8116 Multi-channel DAQ',
    category: 'daq',
    description: 'The KeyDAQ-8116 is a USB 3.0 based multi-channel high-performance dynamic signal acquisition card. With 16 synchronous acquisition channels, 24-bit resolution per channel, and up to 256 kS/s sampling rate. The built-in USB hub allows easy cascading of multiple cards through shared clock and trigger signals, enabling construction of data acquisition systems with dozens or even hundreds of channels.',
    shortDescription: '16-channel USB 3.0 high-performance dynamic signal acquisition system',
    image: '/Img/2025/07/KeyDAQ-8116web.jpg',
    gallery: [
      '/Img/2025/07/KeyDAQ-8116web.jpg',
      '/Img/2025/07/8116.jpg',
    ],
    features: [
      {
        icon: 'LayoutGrid',
        title: '16 Synchronous Channels',
        description: '16-channel synchronized acquisition with 24-bit resolution and up to 256 kS/s sampling rate.'
      },
      {
        icon: 'Usb',
        title: 'USB 3.0 with Hub',
        description: 'USB 3.0 communication with built-in hub for easy multi-card cascading and synchronization.'
      },
      {
        icon: 'Signal',
        title: 'IEPE Excitation',
        description: '4mA IEPE constant current source per channel, software-configurable on/off.'
      },
      {
        icon: 'Layers',
        title: 'Stackable Design',
        description: 'Unique stackable design for space-efficient placement and easy expansion.'
      }
    ],
    specifications: [
      {
        category: 'Analog Input',
        items: [
          { label: 'Channels', value: '16', unit: 'synchronous' },
          { label: 'Resolution', value: '24', unit: 'bit' },
          { label: 'Max Sampling Rate', value: '256', unit: 'kS/s' },
          { label: 'Input Range', value: '±5', unit: 'V' },
          { label: 'Dynamic Range', value: '109', unit: 'dB' },
          { label: 'Coupling', value: 'AC/DC', unit: 'selectable' },
          { label: 'IEPE Excitation', value: '4', unit: 'mA per channel' },
          { label: 'Anti-aliasing Filter', value: 'Built-in', unit: 'per channel' }
        ]
      },
      {
        category: 'Interface & Connectivity',
        items: [
          { label: 'Interface', value: 'USB 3.0', unit: '' },
          { label: 'Connector Type', value: 'BNC', unit: '' },
          { label: 'Multi-card Sync', value: 'Shared clock & trigger', unit: 'via USB hub' }
        ]
      },
      {
        category: 'Physical & Environmental',
        items: [
          { label: 'Power Supply', value: 'External 24V battery', unit: 'supported' },
          { label: 'Design', value: 'Stackable', unit: 'space-efficient' }
        ]
      }
    ],
    applications: [
      {
        id: 'multi-channel',
        title: 'Multi-channel Measurement',
        description: 'Simultaneous measurement from multiple sensors and locations.',
        image: '/Img/2025/07/KeyDAQ-8116web.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'KeyDAQ-8116 Datasheet',
        downloadUrl: '/downloads/KeyDAQ-8116-Datasheet.pdf',
        size: '1.8 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['usb-4228', 'signalpad'],
    seo: {
      title: 'KeyDAQ-8116 16-Channel USB 3.0 Data Acquisition System | KeyGoTech',
      description: 'KeyDAQ-8116 multi-channel high-performance dynamic signal acquisition card with 16 synchronous channels, 24-bit resolution, and multi-card cascading capability.',
      keywords: ['KeyDAQ-8116', '16-channel DAQ', 'USB 3.0 data acquisition', 'dynamic signal acquisition', 'multi-channel synchronized sampling']
    }
  },
  // NVH Software
  {
    id: 'signalpad',
    model: 'SignalPad',
    name: 'SignalPad Measurement & Control Software',
    category: 'nvh-software',
    description: 'SignalPad is a multi-functional signal acquisition and analysis software that enables signal acquisition, storage, playback, analysis, and report generation without programming. It supports various signal types including voltage, current, sound, vibration, strain, temperature, and torque. SignalPad is ideal for NVH testing, acoustic quality testing, machine fault diagnosis, structural dynamic testing, and general data logging applications.',
    shortDescription: 'Multi-functional signal acquisition and analysis software for NVH testing',
    image: '/Img/2026/03/SignalPad-product.jpg',
    gallery: [
      '/Img/2026/03/SignalPad-product.jpg',
      '/Img/2025/07/signalpad2.jpg',
    ],
    features: [
      {
        icon: 'Check',
        title: 'Easy to Use',
        description: 'No programming required for data acquisition, storage, and playback. All configurations can be saved for reuse. Intuitive interface supports touchscreen operation.'
      },
      {
        icon: 'BarChart3',
        title: 'Professional Signal Processing',
        description: 'Power spectrum, filtering, integration, differentiation, statistical analysis, vibration level, sound pressure level, octave, order tracking, and sound quality analysis.'
      },
      {
        icon: 'Settings2',
        title: 'Flexible Interface',
        description: 'Customizable display content and layout. Interface and algorithm configurations can be saved as project files for easy switching between different applications.'
      },
      {
        icon: 'Usb',
        title: 'Plug & Play Hardware',
        description: 'Supports all NI DAQ devices including USB, Ethernet, Wi-Fi, PCI, PXI, and PXIe interfaces. Compatible with voltage, current, temperature, strain, torque, acceleration, and sound pressure signals.'
      }
    ],
    specifications: [
      {
        category: 'Software Modules',
        items: [
          { label: 'Basic Module', value: 'Channel configuration, data acquisition, signal display, statistical analysis, storage/playback, data export', unit: '' },
          { label: 'Signal Processing', value: 'Power spectrum, cross-spectrum, filtering, integration, differentiation, resampling, histogram', unit: '' },
          { label: 'NVH Module', value: 'Vibration level, sound pressure level, octave spectrum calculation and display', unit: '' },
          { label: 'Advanced NVH', value: 'Loudness, sharpness, roughness, fluctuation strength (sound quality analysis)', unit: '' },
          { label: 'Acoustic Analysis', value: 'Sound intensity, sound power measurement', unit: '' },
          { label: 'Rotating Machinery', value: 'Cepstrum, RPM, order analysis, order tracking, envelope, spectrogram, waterfall plot', unit: '' },
          { label: 'Dynamic Characteristics', value: 'Frequency Response Function (FRF) measurement with multiple experimental methods', unit: '' },
          { label: 'Modal Analysis', value: '3D modeling, FRF data acquisition, modal analysis, mode shape correlation, ODS and animation', unit: '' },
          { label: 'Shock Response', value: 'Multi-channel shock vibration acquisition, shock response spectrum calculation with Q-value analysis', unit: '' }
        ]
      },
      {
        category: 'Supported Signal Types',
        items: [
          { label: 'Physical Signals', value: 'Voltage, Current, Sound, Vibration, Strain, Temperature, Torque', unit: '' },
          { label: 'Analysis Types', value: 'Online and offline analysis supported', unit: '' }
        ]
      },
      {
        category: 'System Requirements',
        items: [
          { label: 'OS', value: 'Windows 10/11', unit: '' },
          { label: 'RAM', value: '8 GB minimum', unit: '' },
          { label: 'Storage', value: '10 GB free space', unit: '' },
          { label: 'Display', value: '1920x1080 recommended', unit: '' }
        ]
      }
    ],
    applications: [
      {
        id: 'nvh-testing',
        title: 'NVH Testing',
        description: 'Complete noise, vibration, and harshness testing and analysis.',
        image: '/Img/2026/03/signalpad.jpg'
      },
      {
        id: 'acoustic-analysis',
        title: 'Acoustic Analysis',
        description: 'Professional acoustic measurement and analysis workflows.',
        image: '/Img/2025/07/signalpad2.jpg'
      }
    ],
    downloads: [
      {
        type: 'software',
        title: 'SignalPad Installer',
        downloadUrl: '/downloads/SignalPad-Setup-v4.2.exe',
        size: '285 MB',
        language: 'English'
      },
      {
        type: 'manual',
        title: 'SignalPad User Guide',
        downloadUrl: '/downloads/SignalPad-User-Guide.pdf',
        size: '12 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['usb-4228', 'keydaq-8116', 't144'],
    seo: {
      title: 'SignalPad NVH Analysis Software | KeyGoTech',
      description: 'Comprehensive NVH analysis software for acoustic and vibration testing, data acquisition, and reporting.',
      keywords: ['SignalPad', 'NVH software', 'acoustic analysis software', 'vibration analysis', 'noise testing']
    }
  },
  // Traffic Monitoring
  {
    id: 'horn-capture',
    model: 'Horn Capture System',
    name: 'Fixed Traffic Horn Capture System',
    category: 'traffic-monitoring',
    description: 'KeyGoTech offers independently developed, reliable horn capture systems including fixed, portable and vehicle-mounted versions. Certified by the Ministry of Public Security and the National Institute of Metrology, the systems use advanced sound localization to accurately detect illegal honking and filter out interference. They produce evidence images compliant with GA/T832-2014 and 2-second videos, with data seamlessly integrated into existing traffic police monitoring systems.',
    shortDescription: 'Fixed acoustic traffic horn detection and capture system with MPS certification',
    image: '/Img/2026/03/Horn-Capture System.jpg',
    gallery: [
      '/Img/2026/03/Horn-Capture System.jpg',
    ],
    features: [
      {
        icon: 'Zap',
        title: 'Easy Installation',
        description: 'Can be installed with just one existing traffic pole - no need for two crossbars. Ready to capture violations immediately after installation.'
      },
      {
        icon: 'Clock',
        title: 'Quick Deployment',
        description: 'Industrial-grade product ready to use. System goes live within 24 hours from installation to operation.'
      },
      {
        icon: 'Target',
        title: 'Instant Capture',
        description: 'Locates and identifies license plate numbers within 2 seconds. Video playback shows the horn capture process before and after the event.'
      },
      {
        icon: 'Shield',
        title: 'MPS Certified',
        description: 'Certified by the Ministry of Public Security and National Institute of Metrology. Compliant with GA/T832-2014 technical specifications.'
      }
    ],
    specifications: [
      {
        category: 'Acoustic Probe (Core Component)',
        items: [
          { label: 'Microphone Configuration', value: '32 or 64', unit: 'MEMS microphones' },
          { label: 'SPL Measurement Range', value: '30 ~ 120', unit: 'dBA' },
          { label: 'Frequency Range', value: '200 ~ 8000', unit: 'Hz' }
        ]
      },
      {
        category: 'Detection Performance',
        items: [
          { label: 'Detection Distance', value: 'Up to 50', unit: 'm ahead' },
          { label: 'Detection Width', value: '3 ~ 5', unit: 'lanes' },
          { label: 'Lateral Resolution', value: 'Can distinguish', unit: 'adjacent lane vehicles' },
          { label: 'Longitudinal Resolution', value: 'Can distinguish', unit: 'front/rear vehicles' },
          { label: 'Moving Vehicle Capture', value: 'Supported', unit: 'typical urban speeds' }
        ]
      },
      {
        category: 'Capture Capabilities',
        items: [
          { label: 'License Plate Recognition', value: 'Within 2', unit: 'seconds' },
          { label: 'Video Evidence', value: '2-second', unit: 'sound video' },
          { label: 'Evidence Format', value: 'GA/T832-2014', unit: 'compliant' },
          { label: 'Interference Filtering', value: 'Engine, brake, siren', unit: 'excluded' }
        ]
      }
    ],
    applications: [
      {
        id: 'urban-traffic',
        title: 'Urban Traffic Management',
        description: 'Enforce horn restrictions in city centers and residential areas.',
        image: '/Img/2026/02/交通噪声抓拍系统banner-en.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'Horn Capture System Datasheet',
        downloadUrl: '/downloads/Horn-Capture-System.pdf',
        size: '2.0 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['revved-vehicle-capture'],
    seo: {
      title: 'Fixed Traffic Horn Capture System | KeyGoTech',
      description: 'MPS-certified fixed horn capture system with 32/64 MEMS microphones. Accurate horn detection in 2 seconds, compliant with GA/T832-2014. Deployed in 100+ cities.',
      keywords: ['horn capture system', 'traffic horn detection', 'acoustic traffic enforcement', 'MPS certified', 'GA/T832-2014', 'illegal horn capture']
    }
  },
  {
    id: 'revved-vehicle-capture',
    model: 'Revved Vehicle Capture',
    name: 'Revved Vehicle (Exhaust Noise) Capture System',
    category: 'traffic-monitoring',
    description: 'AI-powered revved vehicle capture system using deep learning and acoustic imaging. Identifies modified vehicles with excessive exhaust noise while filtering out horns, engines, and environmental noise. Automatically generates sound cloud maps and videos as evidence. Covers up to 5 lanes with fixed, vehicle-mounted, and portable deployment options.',
    shortDescription: 'AI-powered revved vehicle capture system with acoustic imaging',
    image: '/Img/2026/03/Revved-Vehicle Capture.jpg',
    gallery: [
      '/Img/2026/03/Revved-Vehicle Capture.jpg',
    ],
    features: [
      {
        icon: 'Brain',
        title: 'AI Acoustic Analysis',
        description: 'Based on deep learning AI acoustic scene analysis technology for accurate identification of revved vehicles.'
      },
      {
        icon: 'Target',
        title: 'High-Resolution Localization',
        description: 'Core microphone array high-resolution localization algorithm for precise vehicle positioning.'
      },
      {
        icon: 'Video',
        title: '4K Acoustic Video',
        description: '4K ultra-clear "acoustic imaging video" with sound cloud maps as visual evidence.'
      },
      {
        icon: 'Filter',
        title: 'AI Noise Classifier',
        description: 'Effectively excludes horn sounds, truck engine noise, and environmental noise interference.'
      },
      {
        icon: 'Scan',
        title: 'Secondary Recognition',
        description: 'Secondary feature recognition server for enhanced identification accuracy.'
      },
      {
        icon: 'LayoutGrid',
        title: 'Multi-Lane Coverage',
        description: 'Covers up to 5 lanes in one direction. Supports fixed, vehicle-mounted, and portable deployment options.'
      }
    ],
    specifications: [
      {
        category: 'AI Technology',
        items: [
          { label: 'Core Technology', value: 'Deep learning', unit: 'AI acoustic analysis' },
          { label: 'Localization', value: 'Microphone array', unit: 'high-resolution algorithm' },
          { label: 'Classifier', value: 'AI noise', unit: 'classifier' },
          { label: 'Recognition', value: 'Secondary feature', unit: 'identification server' }
        ]
      },
      {
        category: 'Capture Capabilities',
        items: [
          { label: 'Target Vehicles', value: 'High-decibel, modified cars', unit: 'motorcycles' },
          { label: 'Video Quality', value: '4K ultra-clear', unit: 'acoustic imaging' },
          { label: 'Lane Coverage', value: 'Up to 5', unit: 'lanes (one direction)' },
          { label: 'Evidence Format', value: 'Sound cloud map', unit: '+ sound video' }
        ]
      },
      {
        category: 'System Functions',
        items: [
          { label: 'Detection', value: 'Exhaust noise', unit: 'high noise capture' },
          { label: 'Video Recording', value: '5+ seconds', unit: 'with audio signal' },
          { label: 'Interference Filter', value: 'Horns, engines', unit: 'environmental noise' },
          { label: 'Deployment', value: 'Fixed / Vehicle-mounted', unit: '/ Portable' }
        ]
      }
    ],
    applications: [
      {
        id: 'noise-enforcement',
        title: 'Noise Pollution Enforcement',
        description: 'Combat illegal vehicle modifications causing noise pollution.',
        image: '/Img/EN/交通噪声抓拍系统banner英文.jpg'
      }
    ],
    downloads: [
      {
        type: 'datasheet',
        title: 'Revved Vehicle Capture Datasheet',
        downloadUrl: '/downloads/Revved-Vehicle-Capture.pdf',
        size: '2.2 MB',
        language: 'English'
      }
    ],
    relatedProducts: ['horn-capture'],
    seo: {
      title: 'Revved Vehicle Capture System | KeyGoTech',
      description: 'AI-powered revved vehicle capture system using deep learning. Automatically identifies modified vehicles with excessive exhaust noise. Generates sound cloud maps and videos as evidence.',
      keywords: ['revved vehicle capture', 'exhaust noise detection', 'modified vehicle detection', 'AI acoustic analysis', 'sound cloud map', 'traffic noise enforcement']
    }
  }
];

export const getProductById = (id: string): Product | undefined => {
  return products.find(p => p.id === id);
};

export const getProductsByCategory = (category: string): Product[] => {
  return products.filter(p => p.category === category);
};

export const getRelatedProducts = (productId: string): Product[] => {
  const product = getProductById(productId);
  if (!product) return [];
  return products.filter(p => product.relatedProducts.includes(p.id));
};

export const productCategories = [
  {
    id: 'handheld',
    name: 'Handheld Acoustic Imagers',
    description: 'Portable acoustic imaging devices for field inspections and maintenance',
    image: '/Img/2026/02/超声声学成像仪banner-en.jpg'
  },
  {
    id: 'fixed',
    name: 'Fixed-mount Systems',
    description: 'Permanent installation acoustic imagers for continuous monitoring',
    image: '/Img/2026/03/Fixed-mount-Systems.jpg'
  },
  {
    id: 'modules',
    name: 'Acoustic Camera Modules',
    description: 'Modular components for OEM integration and custom systems',
    image: '/Img/2025/12/声学成像机芯与模块_01.jpg'
  },
  {
    id: 'cameras',
    name: 'Acoustic Cameras',
    description: 'High-performance acoustic cameras for research and advanced applications',
    image: '/Img/2026/02/通用声学相机banner-en.jpg'
  },
  {
    id: 'daq',
    name: 'Data Acquisition',
    description: 'Professional DAQ systems for acoustic and vibration measurements',
    image: '/Img/2026/02/振动噪声测试系统banner-en.jpg'
  },
  {
    id: 'nvh-software',
    name: 'NVH Software',
    description: 'Analysis software for noise, vibration, and harshness testing',
    image: '/Img/2026/03/SignalPad-product.jpg'
  },
  {
    id: 'traffic-monitoring',
    name: 'Traffic Monitoring',
    description: 'Acoustic-based traffic noise monitoring and enforcement systems',
    image: '/Img/2026/02/交通噪声抓拍系统banner-en.jpg'
  }
];